'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M13 13v8h8v-8h-8zM3 21h8v-8H3v8zM3 3v8h8V3H3zm13.66-1.31L11 7.34 16.66 13l5.66-5.66-5.66-5.65z' });

var Widgets = function Widgets(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Widgets = (0, _pure2.default)(Widgets);
Widgets.muiName = 'SvgIcon';

exports.default = Widgets;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Widgets.js
// module id = 3019
// module chunks = 0